/** A value `cx` accepts: class names, or falsy values that are skipped. */
export type ClassValue = string | false | null | undefined | 0

/**
 * Joins class names and skips falsy values.
 *
 * @example cx(styles.button, isActive && styles.active, className)
 */
export function cx(...classes: ClassValue[]): string {
  return classes.filter(Boolean).join(' ')
}
